import React from "react";
import { Table } from "semantic-ui-react";

function TablaEscuelasRow(props) {
  const handleRowClick = () => props.handleClick(props.item.id);

  return (
    <Table.Row onClick={handleRowClick} style={{ cursor: "pointer" }}>
      <Table.Cell>{props.item.nombre}</Table.Cell>
      <Table.Cell>{props.item.poblacion}</Table.Cell>
      <Table.Cell>{props.item.provincia}</Table.Cell>
    </Table.Row>
  );
}

export default TablaEscuelasRow;



// WEBPACK FOOTER //
// ./src/pages/inscripciones/tablaEscuelas/TablaEscuelasRow.jsx